module.exports = "/_next/static/resources/photo-3-713e9e5b65a8856dcc14b732945ef93e.webp";